import CountryIso from "@/lib/countryIso";
import ContactLocationDto from "../ContactLocations/ContactLocationDto";
import LocationDto from "@/models/Locations/LocationDto";
import BaseUpdateRequest from "../Shared/BaseUpdateRequest";
import GeoPoint from "../Shared/GeoPoint";
import InPersonInterviewAddressType from "./InPersonInterviewAddressType";
import JobWorkerInterviewType from "./JobWorkerInterviewType";
import CompanyAddressDto from "../CompanyAddresses/CompanyAddressDto";

export default class UpdateJobWorkerInterviewDetailsViewModel extends BaseUpdateRequest {
    jobWorkerInterviewId = '';
    date = '';
    startAtTime = '00:00';
    endAtTime = '00:00';
	type: JobWorkerInterviewType = 0;
    selectedContactLocation: ContactLocationDto = new ContactLocationDto();
    inPersonAddressType: InPersonInterviewAddressType = InPersonInterviewAddressType.JobLocation;
    selectedOtherLocation: LocationDto;
    selectedCompanyAddress: CompanyAddressDto;
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    country: CountryIso = new CountryIso();
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    addressSearchText = '';
    workerInstructions = '';
    contactInstructions = '';
}